export interface ICountryList {
  label: string
  code: string
  value: string
  light_icon?: string
  ccode?: string
}

export const CountryList: ICountryList[] = [
  {
    label: 'Afghanistan',
    code: '004',
    value: 'AF',
    ccode: 'AFG',
  },
  {
    label: 'Albania',
    code: '008',
    value: 'AL',
    ccode: 'ALB',
  },
  {
    label: 'Algeria',
    code: '012',
    value: 'DZ',
    ccode: 'DZA',
  },
  {
    label: 'American Samoa',
    code: '016',
    value: 'AS',
    ccode: 'ASM',
  },
  {
    label: 'Andorra',
    code: '020',
    value: 'AD',
    ccode: 'AND',
  },
  {
    label: 'Angola',
    code: '024',
    value: 'AO',
    ccode: 'AGO',
  },
  {
    label: 'Anguilla',
    code: '660',
    value: 'AI',
    ccode: 'AIA',
  },
  {
    label: 'Antarctica',
    code: '010',
    value: 'AQ',
    ccode: 'ATA',
  },
  {
    label: 'Antigua and Barbuda',
    code: '028',
    value: 'AG',
    ccode: 'ATG',
  },
  {
    label: 'Argentina',
    code: '032',
    value: 'AR',
    ccode: 'ARG',
  },
  {
    label: 'Armenia',
    code: '051',
    value: 'AM',
    ccode: 'ARM',
  },
  {
    label: 'Aruba',
    code: '533',
    value: 'AW',
    ccode: 'ABW',
  },
  {
    label: 'Australia',
    code: '036',
    value: 'AU',
    ccode: 'AUS',
  },
  {
    label: 'Austria',
    code: '040',
    value: 'AT',
    ccode: 'AUT',
  },
  {
    label: 'Azerbaijan',
    code: '031',
    value: 'AZ',
    ccode: 'AZE',
  },
  {
    label: 'Bahamas',
    code: '044',
    value: 'BS',
    ccode: 'BHS',
  },
  {
    label: 'Bahrain',
    code: '048',
    value: 'BH',
    ccode: 'BHR',
  },
  {
    label: 'Bangladesh',
    code: '050',
    value: 'BD',
    ccode: 'BGD',
  },
  {
    label: 'Barbados',
    code: '052',
    value: 'BB',
    ccode: 'BRB',
  },
  {
    label: 'Belarus',
    code: '112',
    value: 'BY',
    ccode: 'BLR',
  },
  {
    label: 'Belgium',
    code: '056',
    value: 'BE',
    ccode: 'BEL',
  },
  {
    label: 'Belize',
    code: '084',
    value: 'BZ',
    ccode: 'BLZ',
  },
  {
    label: 'Benin',
    code: '204',
    value: 'BJ',
    ccode: 'BEN',
  },
  {
    label: 'Bermuda',
    code: '060',
    value: 'BM',
    ccode: 'BMU',
  },
  {
    label: 'Bhutan',
    code: '064',
    value: 'BT',
    ccode: 'BTN',
  },
  {
    label: 'Bolivia',
    code: '068',
    value: 'BO',
    ccode: 'BOL',
  },
  {
    label: 'Bosnia and Herzegovina',
    code: '070',
    value: 'BA',
    ccode: 'BIH',
  },
  {
    label: 'Botswana',
    code: '072',
    value: 'BW',
    ccode: 'BWA',
  },
  {
    label: 'Bouvet Island',
    code: '074',
    value: 'BV',
    ccode: 'BVT',
  },
  {
    label: 'Brazil',
    code: '076',
    value: 'BR',
    ccode: 'BRA',
  },
  {
    label: 'British Indian Ocean Territory',
    code: '086',
    value: 'IO',
    ccode: 'IOT',
  },
  {
    label: 'British Virgin Islands',
    code: '092',
    value: 'VG',
    ccode: 'VGB',
  },
  {
    label: 'Brunei',
    code: '096',
    value: 'BN',
    ccode: 'BRN',
  },
  {
    label: 'Bulgaria',
    code: '100',
    value: 'BG',
    ccode: 'BGR',
  },
  {
    label: 'Burkina Faso',
    code: '854',
    value: 'BF',
    ccode: 'BFA',
  },
  {
    label: 'Burundi',
    code: '108',
    value: 'BI',
    ccode: 'BDI',
  },
  {
    label: 'Cambodia',
    code: '116',
    value: 'KH',
    ccode: 'KHM',
  },
  {
    label: 'Cameroon',
    code: '120',
    value: 'CM',
    ccode: 'CMR',
  },
  {
    label: 'Canada',
    code: '124',
    value: 'CA',
    ccode: 'CAN',
  },
  {
    label: 'Cape Verde',
    code: '132',
    value: 'CV',
    ccode: 'CPV',
  },
  {
    label: 'Caribbean Netherlands',
    code: '535',
    value: 'BQ',
    ccode: 'BES',
  },
  {
    label: 'Cayman Islands',
    code: '136',
    value: 'KY',
    ccode: 'CYM',
  },
  {
    label: 'Central African Republic',
    code: '140',
    value: 'CF',
    ccode: 'CAF',
  },
  {
    label: 'Chad',
    code: '148',
    value: 'TD',
    ccode: 'TCD',
  },
  {
    label: 'Chile',
    code: '152',
    value: 'CL',
    ccode: 'CHL',
  },
  {
    label: 'China',
    code: '156',
    value: 'CN',
    ccode: 'CHN',
  },
  {
    label: 'Christmas Island',
    code: '162',
    value: 'CX',
    ccode: 'CXR',
  },
  {
    label: 'Cocos (Keeling) Islands',
    code: '166',
    value: 'CC',
    ccode: 'CCK',
  },
  {
    label: 'Colombia',
    code: '170',
    value: 'CO',
    ccode: 'COL',
  },
  {
    label: 'Comoros',
    code: '174',
    value: 'KM',
    ccode: 'COM',
  },
  {
    label: 'Cook Islands',
    code: '184',
    value: 'CK',
    ccode: 'COK',
  },
  {
    label: 'Costa Rica',
    code: '188',
    value: 'CR',
    ccode: 'CRI',
  },
  {
    label: 'Croatia',
    code: '191',
    value: 'HR',
    ccode: 'HRV',
  },
  {
    label: 'Cuba',
    code: '192',
    value: 'CU',
    ccode: 'CUB',
  },
  {
    label: 'Curaçao',
    code: '531',
    value: 'CW',
    ccode: 'CUW',
  },
  {
    label: 'Cyprus',
    code: '196',
    value: 'CY',
    ccode: 'CYP',
  },
  {
    label: 'Czechia',
    code: '203',
    value: 'CZ',
    ccode: 'CZE',
  },
  {
    label: 'DR Congo',
    code: '180',
    value: 'CD',
    ccode: 'COD',
  },
  {
    label: 'Denmark',
    code: '208',
    value: 'DK',
    ccode: 'DNK',
  },
  {
    label: 'Djibouti',
    code: '262',
    value: 'DJ',
    ccode: 'DJI',
  },
  {
    label: 'Dominica',
    code: '212',
    value: 'DM',
    ccode: 'DMA',
  },
  {
    label: 'Dominican Republic',
    code: '214',
    value: 'DO',
    ccode: 'DOM',
  },
  {
    label: 'Ecuador',
    code: '218',
    value: 'EC',
    ccode: 'ECU',
  },
  {
    label: 'Egypt',
    code: '818',
    value: 'EG',
    ccode: 'EGY',
  },
  {
    label: 'El Salvador',
    code: '222',
    value: 'SV',
    ccode: 'SLV',
  },
  {
    label: 'Equatorial Guinea',
    code: '226',
    value: 'GQ',
    ccode: 'GNQ',
  },
  {
    label: 'Eritrea',
    code: '232',
    value: 'ER',
    ccode: 'ERI',
  },
  {
    label: 'Estonia',
    code: '233',
    value: 'EE',
    ccode: 'EST',
  },
  {
    label: 'Eswatini',
    code: '748',
    value: 'SZ',
    ccode: 'SWZ',
  },
  {
    label: 'Ethiopia',
    code: '231',
    value: 'ET',
    ccode: 'ETH',
  },
  {
    label: 'Falkland Islands',
    code: '238',
    value: 'FK',
    ccode: 'FLK',
  },
  {
    label: 'Faroe Islands',
    code: '234',
    value: 'FO',
    ccode: 'FRO',
  },
  {
    label: 'Fiji',
    code: '242',
    value: 'FJ',
    ccode: 'FJI',
  },
  {
    label: 'Finland',
    code: '246',
    value: 'FI',
    ccode: 'FIN',
  },
  {
    label: 'France',
    code: '250',
    value: 'FR',
    ccode: 'FRA',
  },
  {
    label: 'French Guiana',
    code: '254',
    value: 'GF',
    ccode: 'GUF',
  },
  {
    label: 'French Polynesia',
    code: '258',
    value: 'PF',
    ccode: 'PYF',
  },
  {
    label: 'French Southern and Antarctic Lands',
    code: '260',
    value: 'TF',
    ccode: 'ATF',
  },
  {
    label: 'Gabon',
    code: '266',
    value: 'GA',
    ccode: 'GAB',
  },
  {
    label: 'Gambia',
    code: '270',
    value: 'GM',
    ccode: 'GMB',
  },
  {
    label: 'Georgia',
    code: '268',
    value: 'GE',
    ccode: 'GEO',
  },
  {
    label: 'Germany',
    code: '276',
    value: 'DE',
    ccode: 'DEU',
  },
  {
    label: 'Ghana',
    code: '288',
    value: 'GH',
    ccode: 'GHA',
  },
  {
    label: 'Gibraltar',
    code: '292',
    value: 'GI',
    ccode: 'GIB',
  },
  {
    label: 'Greece',
    code: '300',
    value: 'GR',
    ccode: 'GRC',
  },
  {
    label: 'Greenland',
    code: '304',
    value: 'GL',
    ccode: 'GRL',
  },
  {
    label: 'Grenada',
    code: '308',
    value: 'GD',
    ccode: 'GRD',
  },
  {
    label: 'Guadeloupe',
    code: '312',
    value: 'GP',
    ccode: 'GLP',
  },
  {
    label: 'Guam',
    code: '316',
    value: 'GU',
    ccode: 'GUM',
  },
  {
    label: 'Guatemala',
    code: '320',
    value: 'GT',
    ccode: 'GTM',
  },
  {
    label: 'Guernsey',
    code: '831',
    value: 'GG',
    ccode: 'GGY',
  },
  {
    label: 'Guinea',
    code: '324',
    value: 'GN',
    ccode: 'GIN',
  },
  {
    label: 'Guinea-Bissau',
    code: '624',
    value: 'GW',
    ccode: 'GNB',
  },
  {
    label: 'Guyana',
    code: '328',
    value: 'GY',
    ccode: 'GUY',
  },
  {
    label: 'Haiti',
    code: '332',
    value: 'HT',
    ccode: 'HTI',
  },
  {
    label: 'Heard Island and McDonald Islands',
    code: '334',
    value: 'HM',
    ccode: 'HMD',
  },
  {
    label: 'Honduras',
    code: '340',
    value: 'HN',
    ccode: 'HND',
  },
  {
    label: 'Hong Kong',
    code: '344',
    value: 'HK',
    ccode: 'HKG',
  },
  {
    label: 'Hungary',
    code: '348',
    value: 'HU',
    ccode: 'HUN',
  },
  {
    label: 'Iceland',
    code: '352',
    value: 'IS',
    ccode: 'ISL',
  },
  {
    label: 'India',
    code: '356',
    value: 'IN',
    ccode: 'IND',
  },
  {
    label: 'Indonesia',
    code: '360',
    value: 'ID',
    ccode: 'IDN',
  },
  {
    label: 'Iran',
    code: '364',
    value: 'IR',
    ccode: 'IRN',
  },
  {
    label: 'Iraq',
    code: '368',
    value: 'IQ',
    ccode: 'IRQ',
  },
  {
    label: 'Ireland',
    code: '372',
    value: 'IE',
    ccode: 'IRL',
  },
  {
    label: 'Isle of Man',
    code: '833',
    value: 'IM',
    ccode: 'IMN',
  },
  {
    label: 'Israel',
    code: '376',
    value: 'IL',
    ccode: 'ISR',
  },
  {
    label: 'Italy',
    code: '380',
    value: 'IT',
    ccode: 'ITA',
  },
  {
    label: 'Ivory Coast',
    code: '384',
    value: 'CI',
    ccode: 'CIV',
  },
  {
    label: 'Jamaica',
    code: '388',
    value: 'JM',
    ccode: 'JAM',
  },
  {
    label: 'Japan',
    code: '392',
    value: 'JP',
    ccode: 'JPN',
  },
  {
    label: 'Jersey',
    code: '832',
    value: 'JE',
    ccode: 'JEY',
  },
  {
    label: 'Jordan',
    code: '400',
    value: 'JO',
    ccode: 'JOR',
  },
  {
    label: 'Kazakhstan',
    code: '398',
    value: 'KZ',
    ccode: 'KAZ',
  },
  {
    label: 'Kenya',
    code: '404',
    value: 'KE',
    ccode: 'KEN',
  },
  {
    label: 'Kiribati',
    code: '296',
    value: 'KI',
    ccode: 'KIR',
  },
  {
    label: 'Kosovo',
    code: '383',
    value: 'XK',
    ccode: 'UNK',
  },
  {
    label: 'Kuwait',
    code: '414',
    value: 'KW',
    ccode: 'KWT',
  },
  {
    label: 'Kyrgyzstan',
    code: '417',
    value: 'KG',
    ccode: 'KGZ',
  },
  {
    label: 'Laos',
    code: '418',
    value: 'LA',
    ccode: 'LAO',
  },
  {
    label: 'Latvia',
    code: '428',
    value: 'LV',
    ccode: 'LVA',
  },
  {
    label: 'Lebanon',
    code: '422',
    value: 'LB',
    ccode: 'LBN',
  },
  {
    label: 'Lesotho',
    code: '426',
    value: 'LS',
    ccode: 'LSO',
  },
  {
    label: 'Liberia',
    code: '430',
    value: 'LR',
    ccode: 'LBR',
  },
  {
    label: 'Libya',
    code: '434',
    value: 'LY',
    ccode: 'LBY',
  },
  {
    label: 'Liechtenstein',
    code: '438',
    value: 'LI',
    ccode: 'LIE',
  },
  {
    label: 'Lithuania',
    code: '440',
    value: 'LT',
    ccode: 'LTU',
  },
  {
    label: 'Luxembourg',
    code: '442',
    value: 'LU',
    ccode: 'LUX',
  },
  {
    label: 'Macau',
    code: '446',
    value: 'MO',
    ccode: 'MAC',
  },
  {
    label: 'Madagascar',
    code: '450',
    value: 'MG',
    ccode: 'MDG',
  },
  {
    label: 'Malawi',
    code: '454',
    value: 'MW',
    ccode: 'MWI',
  },
  {
    label: 'Malaysia',
    code: '458',
    value: 'MY',
    ccode: 'MYS',
  },
  {
    label: 'Maldives',
    code: '462',
    value: 'MV',
    ccode: 'MDV',
  },
  {
    label: 'Mali',
    code: '466',
    value: 'ML',
    ccode: 'MLI',
  },
  {
    label: 'Malta',
    code: '470',
    value: 'MT',
    ccode: 'MLT',
  },
  {
    label: 'Marshall Islands',
    code: '584',
    value: 'MH',
    ccode: 'MHL',
  },
  {
    label: 'Martinique',
    code: '474',
    value: 'MQ',
    ccode: 'MTQ',
  },
  {
    label: 'Mauritania',
    code: '478',
    value: 'MR',
    ccode: 'MRT',
  },
  {
    label: 'Mauritius',
    code: '480',
    value: 'MU',
    ccode: 'MUS',
  },
  {
    label: 'Mayotte',
    code: '175',
    value: 'YT',
    ccode: 'MYT',
  },
  {
    label: 'Mexico',
    code: '484',
    value: 'MX',
    ccode: 'MEX',
  },
  {
    label: 'Micronesia',
    code: '583',
    value: 'FM',
    ccode: 'FSM',
  },
  {
    label: 'Moldova',
    code: '498',
    value: 'MD',
    ccode: 'MDA',
  },
  {
    label: 'Monaco',
    code: '492',
    value: 'MC',
    ccode: 'MCO',
  },
  {
    label: 'Mongolia',
    code: '496',
    value: 'MN',
    ccode: 'MNG',
  },
  {
    label: 'Montenegro',
    code: '499',
    value: 'ME',
    ccode: 'MNE',
  },
  {
    label: 'Montserrat',
    code: '500',
    value: 'MS',
    ccode: 'MSR',
  },
  {
    label: 'Morocco',
    code: '504',
    value: 'MA',
    ccode: 'MAR',
  },
  {
    label: 'Mozambique',
    code: '508',
    value: 'MZ',
    ccode: 'MOZ',
  },
  {
    label: 'Myanmar',
    code: '104',
    value: 'MM',
    ccode: 'MMR',
  },
  {
    label: 'Namibia',
    code: '516',
    value: 'NA',
    ccode: 'NAM',
  },
  {
    label: 'Nauru',
    code: '520',
    value: 'NR',
    ccode: 'NRU',
  },
  {
    label: 'Nepal',
    code: '524',
    value: 'NP',
    ccode: 'NPL',
  },
  {
    label: 'Netherlands',
    code: '528',
    value: 'NL',
    ccode: 'NLD',
  },
  {
    label: 'New Caledonia',
    code: '540',
    value: 'NC',
    ccode: 'NCL',
  },
  {
    label: 'New Zealand',
    code: '554',
    value: 'NZ',
    ccode: 'NZL',
  },
  {
    label: 'Nicaragua',
    code: '558',
    value: 'NI',
    ccode: 'NIC',
  },
  {
    label: 'Niger',
    code: '562',
    value: 'NE',
    ccode: 'NER',
  },
  {
    label: 'Nigeria',
    code: '566',
    value: 'NG',
    ccode: 'NGA',
  },
  {
    label: 'Niue',
    code: '570',
    value: 'NU',
    ccode: 'NIU',
  },
  {
    label: 'Norfolk Island',
    code: '574',
    value: 'NF',
    ccode: 'NFK',
  },
  {
    label: 'North Korea',
    code: '408',
    value: 'KP',
    ccode: 'PRK',
  },
  {
    label: 'North Macedonia',
    code: '807',
    value: 'MK',
    ccode: 'MKD',
  },
  {
    label: 'Northern Mariana Islands',
    code: '580',
    value: 'MP',
    ccode: 'MNP',
  },
  {
    label: 'Norway',
    code: '578',
    value: 'NO',
    ccode: 'NOR',
  },
  {
    label: 'Oman',
    code: '512',
    value: 'OM',
    ccode: 'OMN',
  },
  {
    label: 'Pakistan',
    code: '586',
    value: 'PK',
    ccode: 'PAK',
  },
  {
    label: 'Palau',
    code: '585',
    value: 'PW',
    ccode: 'PLW',
  },
  {
    label: 'Palestine',
    code: '275',
    value: 'PS',
    ccode: 'PSE',
  },
  {
    label: 'Panama',
    code: '591',
    value: 'PA',
    ccode: 'PAN',
  },
  {
    label: 'Papua New Guinea',
    code: '598',
    value: 'PG',
    ccode: 'PNG',
  },
  {
    label: 'Paraguay',
    code: '600',
    value: 'PY',
    ccode: 'PRY',
  },
  {
    label: 'Peru',
    code: '604',
    value: 'PE',
    ccode: 'PER',
  },
  {
    label: 'Philippines',
    code: '608',
    value: 'PH',
    ccode: 'PHL',
  },
  {
    label: 'Pitcairn Islands',
    code: '612',
    value: 'PN',
    ccode: 'PCN',
  },
  {
    label: 'Poland',
    code: '616',
    value: 'PL',
    ccode: 'POL',
  },
  {
    label: 'Portugal',
    code: '620',
    value: 'PT',
    ccode: 'PRT',
  },
  {
    label: 'Puerto Rico',
    code: '630',
    value: 'PR',
    ccode: 'PRI',
  },
  {
    label: 'Qatar',
    code: '634',
    value: 'QA',
    ccode: 'QAT',
  },
  {
    label: 'Republic of the Congo',
    code: '178',
    value: 'CG',
    ccode: 'COG',
  },
  {
    label: 'Romania',
    code: '642',
    value: 'RO',
    ccode: 'ROU',
  },
  {
    label: 'Russia',
    code: '643',
    value: 'RU',
    ccode: 'RUS',
  },
  {
    label: 'Rwanda',
    code: '646',
    value: 'RW',
    ccode: 'RWA',
  },
  {
    label: 'Réunion',
    code: '638',
    value: 'RE',
    ccode: 'REU',
  },
  {
    label: 'Saint Barthélemy',
    code: '652',
    value: 'BL',
    ccode: 'BLM',
  },
  {
    label: 'Saint Helena, Ascension and Tristan da Cunha',
    code: '654',
    value: 'SH',
    ccode: 'SHN',
  },
  {
    label: 'Saint Kitts and Nevis',
    code: '659',
    value: 'KN',
    ccode: 'KNA',
  },
  {
    label: 'Saint Lucia',
    code: '662',
    value: 'LC',
    ccode: 'LCA',
  },
  {
    label: 'Saint Martin',
    code: '663',
    value: 'MF',
    ccode: 'MAF',
  },
  {
    label: 'Saint Pierre and Miquelon',
    code: '666',
    value: 'PM',
    ccode: 'SPM',
  },
  {
    label: 'Saint Vincent and the Grenadines',
    code: '670',
    value: 'VC',
    ccode: 'VCT',
  },
  {
    label: 'Samoa',
    code: '882',
    value: 'WS',
    ccode: 'WSM',
  },
  {
    label: 'San Marino',
    code: '674',
    value: 'SM',
    ccode: 'SMR',
  },
  {
    label: 'Saudi Arabia',
    code: '682',
    value: 'SA',
    ccode: 'SAU',
  },
  {
    label: 'Senegal',
    code: '686',
    value: 'SN',
    ccode: 'SEN',
  },
  {
    label: 'Serbia',
    code: '688',
    value: 'RS',
    ccode: 'SRB',
  },
  {
    label: 'Seychelles',
    code: '690',
    value: 'SC',
    ccode: 'SYC',
  },
  {
    label: 'Sierra Leone',
    code: '694',
    value: 'SL',
    ccode: 'SLE',
  },
  {
    label: 'Singapore',
    code: '702',
    value: 'SG',
    ccode: 'SGP',
  },
  {
    label: 'Sint Maarten',
    code: '534',
    value: 'SX',
    ccode: 'SXM',
  },
  {
    label: 'Slovakia',
    code: '703',
    value: 'SK',
    ccode: 'SVK',
  },
  {
    label: 'Slovenia',
    code: '705',
    value: 'SI',
    ccode: 'SVN',
  },
  {
    label: 'Solomon Islands',
    code: '090',
    value: 'SB',
    ccode: 'SLB',
  },
  {
    label: 'Somalia',
    code: '706',
    value: 'SO',
    ccode: 'SOM',
  },
  {
    label: 'South Africa',
    code: '710',
    value: 'ZA',
    ccode: 'ZAF',
  },
  {
    label: 'South Georgia',
    code: '239',
    value: 'GS',
    ccode: 'SGS',
  },
  {
    label: 'South Korea',
    code: '410',
    value: 'KR',
    ccode: 'KOR',
  },
  {
    label: 'South Sudan',
    code: '728',
    value: 'SS',
    ccode: 'SSD',
  },
  {
    label: 'Spain',
    code: '724',
    value: 'ES',
    ccode: 'ESP',
  },
  {
    label: 'Sri Lanka',
    code: '144',
    value: 'LK',
    ccode: 'LKA',
  },
  {
    label: 'Sudan',
    code: '729',
    value: 'SD',
    ccode: 'SDN',
  },
  {
    label: 'Suriname',
    code: '740',
    value: 'SR',
    ccode: 'SUR',
  },
  {
    label: 'Svalbard and Jan Mayen',
    code: '744',
    value: 'SJ',
    ccode: 'SJM',
  },
  {
    label: 'Sweden',
    code: '752',
    value: 'SE',
    ccode: 'SWE',
  },
  {
    label: 'Switzerland',
    code: '756',
    value: 'CH',
    ccode: 'CHE',
  },
  {
    label: 'Syria',
    code: '760',
    value: 'SY',
    ccode: 'SYR',
  },
  {
    label: 'São Tomé and Príncipe',
    code: '678',
    value: 'ST',
    ccode: 'STP',
  },
  {
    label: 'Taiwan',
    code: '158',
    value: 'TW',
    ccode: 'TWN',
  },
  {
    label: 'Tajikistan',
    code: '762',
    value: 'TJ',
    ccode: 'TJK',
  },
  {
    label: 'Tanzania',
    code: '834',
    value: 'TZ',
    ccode: 'TZA',
  },
  {
    label: 'Thailand',
    code: '764',
    value: 'TH',
    ccode: 'THA',
  },
  {
    label: 'Timor-Leste',
    code: '626',
    value: 'TL',
    ccode: 'TLS',
  },
  {
    label: 'Togo',
    code: '768',
    value: 'TG',
    ccode: 'TGO',
  },
  {
    label: 'Tokelau',
    code: '772',
    value: 'TK',
    ccode: 'TKL',
  },
  {
    label: 'Tonga',
    code: '776',
    value: 'TO',
    ccode: 'TON',
  },
  {
    label: 'Trinidad and Tobago',
    code: '780',
    value: 'TT',
    ccode: 'TTO',
  },
  {
    label: 'Tunisia',
    code: '788',
    value: 'TN',
    ccode: 'TUN',
  },
  {
    label: 'Turkey',
    code: '792',
    value: 'TR',
    ccode: 'TUR',
  },
  {
    label: 'Turkmenistan',
    code: '795',
    value: 'TM',
    ccode: 'TKM',
  },
  {
    label: 'Turks and Caicos Islands',
    code: '796',
    value: 'TC',
    ccode: 'TCA',
  },
  {
    label: 'Tuvalu',
    code: '798',
    value: 'TV',
    ccode: 'TUV',
  },
  {
    label: 'Uganda',
    code: '800',
    value: 'UG',
    ccode: 'UGA',
  },
  {
    label: 'Ukraine',
    code: '804',
    value: 'UA',
    ccode: 'UKR',
  },
  {
    label: 'United Arab Emirates',
    code: '784',
    value: 'AE',
    ccode: 'ARE',
  },
  {
    label: 'United Kingdom',
    code: '826',
    value: 'GB',
    ccode: 'GBR',
  },
  {
    label: 'United States',
    code: '840',
    value: 'US',
    ccode: 'USA',
  },
  {
    label: 'United States Minor Outlying Islands',
    code: '581',
    value: 'UM',
    ccode: 'UMI',
  },
  {
    label: 'United States Virgin Islands',
    code: '850',
    value: 'VI',
    ccode: 'VIR',
  },
  {
    label: 'Uruguay',
    code: '858',
    value: 'UY',
    ccode: 'URY',
  },
  {
    label: 'Uzbekistan',
    code: '860',
    value: 'UZ',
    ccode: 'UZB',
  },
  {
    label: 'Vanuatu',
    code: '548',
    value: 'VU',
    ccode: 'VUT',
  },
  {
    label: 'Vatican City',
    code: '336',
    value: 'VA',
    ccode: 'VAT',
  },
  {
    label: 'Venezuela',
    code: '862',
    value: 'VE',
    ccode: 'VEN',
  },
  {
    label: 'Vietnam',
    code: '704',
    value: 'VN',
    ccode: 'VNM',
  },
  {
    label: 'Wallis and Futuna',
    code: '876',
    value: 'WF',
    ccode: 'WLF',
  },
  {
    label: 'Western Sahara',
    code: '732',
    value: 'EH',
    ccode: 'ESH',
  },
  {
    label: 'Yemen',
    code: '887',
    value: 'YE',
    ccode: 'YEM',
  },
  {
    label: 'Zambia',
    code: '894',
    value: 'ZM',
    ccode: 'ZMB',
  },
  {
    label: 'Zimbabwe',
    code: '716',
    value: 'ZW',
    ccode: 'ZWE',
  },
  {
    label: 'Åland Islands',
    code: '248',
    value: 'AX',
    ccode: 'ALA',
  },
]
